/**
 * Calculates exponential backoff delay with jitter (replicates Apollo's implementation).
 *
 * Mirrors `apollo-link-retry`'s `buildDelayFunction` exactly:
 *
 *     const delay = Math.min(max, baseDelay * Math.pow(2, count));
 *     return jitter ? Math.random() * delay : delay;
 *
 * The jitter must be applied to the capped value and must not be scaled further — an extra factor
 * both doubles the average wait and lets the result exceed `maxDelayMs`.
 *
 * @see https://www.apollographql.com/docs/react/api/link/apollo-link-retry#avoiding-thundering-herd
 */
export const calculateExponentialBackoff = (
	attempt: number,
	initialDelayMs: number,
	maxDelayMs: number,
): number => {
	const exponentialDelay = Math.min(initialDelayMs * Math.pow(2, attempt), maxDelayMs);

	return Math.random() * exponentialDelay;
};
